import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { PdfExportConfiguration } from '../../models';

export interface IExportToPdfService {
    print(configuration: any, language?: string): angular.IPromise<void>;
    getStorage(dashboardGuid: string): angular.IPromise<string[]>;
    downloadStoredFile(dashboardGuid: string, fileName: string): angular.IPromise<void>;
}

export class ExportToPdfService implements IExportToPdfService {
    static serviceId = 'exportToPdfService';

    static $inject = [
        'requestService',
        '$window'
    ];

    constructor(
        private _requestService: IRequestService,
        private _$window: angular.IWindowService
    ) {
    }

    print(configuration: PdfExportConfiguration, language?: string): angular.IPromise<void> {
        if (language) {
            configuration.language = language;
        }
        configuration.isPrinting = true;
        let children;
        let parent;
        if (configuration.group) {
            parent = configuration.group.parent;
            delete configuration.group.parent;

            if (configuration.group.children) {
                children = configuration.group.children;
                delete configuration.group.children;
            }
        }
        return this._requestService
            .postAtV1('exportToPdf/print', configuration)
            .then((address: string) => {
                if (children) {
                    configuration.group.children = children;
                    configuration.group.parent = parent;
                }
                this._requestService.cleanCacheAtV1(`exportToPdf/storage/${configuration.dashboard.guid}`);
                this._$window.open(this._requestService.getApiUrl() + address);
            })
            .finally(() => configuration.isPrinting = false);
    }

    getStorage(dashboardGuid: string): angular.IPromise<string[]> {
        return this._requestService.getAtV1(`exportToPdf/storage/${dashboardGuid}`);
    }

    downloadStoredFile(dashboardGuid: string, fileName: string): angular.IPromise<void> {
        return this._requestService.postAtV1(`exportToPdf/storage/${dashboardGuid}?name=${fileName}`)
            .then(address => {
                this._$window.open(this._requestService.getApiUrl() + address);
            });
    }
}